import {
  type Date,
  type SourceAccountMetricPoint,
  type SourceAccountMetricSeriesData as GQLMetricSeries,
} from "@digits-graphql/frontend/graphql-bearer"
import dateTimeHelper from "@digits-shared/helpers/dateTimeHelper"

export interface MetricSeries {
  label: string
  iconObjectName?: string
  values: MetricsValues
}

export interface MetricValue {
  timestamp: Date
  value: number
}
export type MetricsValues = MetricValue[]

export function toMetricValue(point: SourceAccountMetricPoint): MetricValue {
  return {
    timestamp: dateTimeHelper.coerceDateFromUnixTimestamp(point.time),
    value: point.value,
  }
}

export function toMetricSeries(metrics: GQLMetricSeries | undefined): MetricSeries {
  if (!metrics) {
    return {
      label: "",
      values: [],
    }
  }

  return {
    label: metrics.label,
    iconObjectName: metrics.iconObjectName || undefined,
    values: metrics.series.points.map(toMetricValue),
  }
}

export function toSortedMetricSeries(metrics: GQLMetricSeries | undefined): MetricSeries {
  if (!metrics) {
    return {
      label: "",
      values: [],
    }
  }

  return {
    label: metrics.label,
    iconObjectName: metrics.iconObjectName || undefined,
    values: metrics.series.points.sort(sortMetricValues).map(toMetricValue),
  }
}

export const sortMetricValues = (a: SourceAccountMetricPoint, b: SourceAccountMetricPoint) =>
  a.time - b.time
